import { XingletWrapper } from './xinglet-helpers';
import type { XingletInterface } from './xinglet-helpers';

export type TemplatesProps = {
  onToggle: () => void;
  isShown: boolean;
};

export type TemplatesXinglet = XingletInterface<TemplatesProps>;
export const Templates = XingletWrapper<TemplatesProps>(
  '@xing-com/crate-lebenslauf-components-templates-popup'
);
